import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M131.8 25.2H109.4V11.2C109.4 5.0225 104.377 0 98.2 0H42.2C36.0225 0 31 5.0225 31 11.2V25.2H8.6C5.5025 25.2 3 27.7025 3 30.8V36.4C3 37.17 3.63 37.8 4.4 37.8H14.97L19.2925 129.325C19.5725 135.292 24.5075 140 30.475 140H109.925C115.91 140 120.827 135.31 121.108 129.325L125.43 37.8H136C136.77 37.8 137.4 37.17 137.4 36.4V30.8C137.4 27.7025 134.897 25.2 131.8 25.2ZM96.8 25.2H43.6V12.6H96.8V25.2Z",
		fill: "#26292E"
	})
});
export default SvgTrash;
